<template>
  <div class="role_links">

    <span v-show="role == 'Operator'">
      <router-link @click.native="closeMenu()" to="/pmcs">PMCSx</router-link>
      <router-link @click.native="closeMenu()" to="/myfaults"
        >My PMCSx Faults</router-link
      >
      <router-link @click.native="closeMenu()" to="/dispatch"
        >Request Dispatch</router-link
      >
      <!-- <router-link @click.native="closeMenu()" to="/appointment"
        >Schedule Appt</router-link
      > -->
    </span>

    <span v-show="role == 'Mechanic'">
      <router-link @click.native="closeMenu()" to="/assigned"
        >My Assigned Work
        <span v-show="MechanicNotifications.length > 0" class="notassigned p-badge badge-fix">{{ MechanicNotifications.length }}</span>
      </router-link>
      <router-link @click.native="closeMenu()" to="/partsrequest"
        >Parts Request Form</router-link
      >
      <div class="separator"></div>
      <router-link @click.native="closeMenu()" to="/pmcs">PMCSx</router-link>
      <router-link @click.native="closeMenu()" to="/myfaults"
        >My PMCSx Faults</router-link
      >
    </span>

    <span v-show="role == 'Org. Leader'">
      <!-- <router-link @click.native="closeMenu()" to="/leaddashboard"
        >Leaders Dashboard</router-link
      > -->
      <router-link @click.native="closeMenu()" to="/myunitsfaults"
        >My Unit's Faults</router-link
      >
      <div class="separator"></div>
      <router-link @click.native="closeMenu()" to="/pmcs">PMCSx</router-link>
      <router-link @click.native="closeMenu()" to="/myfaults"
        >My PMCSx Faults</router-link
      >
      <!-- <router-link @click.native="closeMenu()" to="/dispatch"
        >Request Dispatch</router-link
      > -->
      <!-- <router-link @click.native="closeMenu()" to="/appointment"
        >Schedule Appt</router-link
      > -->
    </span>

    <span v-show="role == 'Clerk'">
      <span >
        <router-link @click.native="closeMenu()" to="/addtogcss" class="p-overlay-badge" 
          >New Faults Reported<span class="notentered p-badge badge-fix">{{ notentered.length }}</span>
          </router-link>
      </span>
      <!-- <router-link @click.native="closeMenu()" to="/newdispatch"
        >New Dispatch Requests</router-link
      > -->

      <span >
        <router-link @click.native="closeMenu()" to="/newpartsreq" class="p-overlay-badge" 
          >New Parts to Order<span v-show="parts.length > 0" class="approved p-badge badge-fix">{{ parts.length }}</span></router-link>
      </span>

      <div class="separator"></div>
      <router-link @click.native="closeMenu()" to="/pmcs">PMCSx</router-link>
      <router-link @click.native="closeMenu()" to="/myfaults"
        >My PMCSx Faults</router-link
      >
    </span>

    <span v-show="role == 'Maint. Manager'">
      <span >
        <router-link @click.native="closeMenu()" to="/faultsworkbench" class="p-overlay-badge"
        :class="{'router-link-exact-active':$route.name == 'VerifiedFaults' || $route.name == 'Assigned' || $route.name == 'NewFaults'}">
          My Workbench
          <!-- <span class="notassigned p-badge badge-fix">{{ notassigned.length }}</span>
          <span class="assigned p-badge badge-fix">{{ assigned.length }}</span>
          <span class="verified p-badge badge-fix">{{ verified.length }}</span> -->
          <span v-show="MMnotifications.length > 0" class="notassigned p-badge badge-fix">{{ MMnotifications.length }}</span>
          </router-link>
      </span>

            <!-- <router-link @click.native="closeMenu()" to="/mmismanager"
        >MMIS Manager</router-link
      > -->

            <router-link @click.native="closeMenu()" to="/smartfacility"
        >Smart Facility</router-link
      >

      <router-link @click.native="closeMenu()" to="/partsrequest"
        >Parts Request Form</router-link
      >

      <div class="separator"></div>
      <router-link @click.native="closeMenu()" to="/pmcs">PMCSx</router-link>
      <router-link @click.native="closeMenu()" to="/myfaults"
        >My PMCSx Faults</router-link
      >

      <div class="separator"></div>
      <!-- <router-link @click.native="closeMenu()" to="/upload">App File Upload</router-link> -->
      <!-- <router-link @click.native="closeMenu()" to="/leaddashboard"
        >Leaders Dashboard</router-link
      > -->
      <router-link @click.native="closeMenu()" to="/myunitsfaults"
        >My Unit's Faults</router-link
      >

      <span >
        <router-link @click.native="closeMenu()" to="/users" class="p-overlay-badge" 
          >Edit Users<span v-show="approved.length > 0" class="approved p-badge badge-fix">{{ approved.length }}</span></router-link>
      </span>
    </span>

        <span v-show="role == 'Tool Room Manager'">
      <span >
        <router-link @click.native="closeMenu()" to="/assigned" class="p-overlay-badge">
          My Assigned Work
          <span class="assigned p-badge badge-fix">{{ assigned.length }}</span>

          </router-link>
      </span>

      <router-link @click.native="closeMenu()" to="/partsrequest"
        >Parts Request Form</router-link
      >

      <div class="separator"></div>
      <router-link @click.native="closeMenu()" to="/pmcs">PMCSx</router-link>
      <router-link @click.native="closeMenu()" to="/myfaults"
        >My PMCSx Faults</router-link
      >

    </span>

  </div>
</template>

<script>
import { fb_db, fb_users, fs, fb_faults, fb_auth, fb_parts } from "../firebase";
import router from "../router";

export default {
  name: "RoleLinks",
  props: {
    role: String,
  },
  data() {
    return {
      login: { nickname: "" },
      faults: [],
      faultsOberver: null,
      approvedObserver: null,
      partsObserver: null,
      approved:[],
      parts:[],
    };

  },
  async created() {
    let userData = await fb_users.doc(fb_auth.currentUser.uid).get()
    let user = userData.data();

    const faultsRef = fb_db.collection("faults").where("puic", "==", user.puic)
    this.faultsOberver = faultsRef.onSnapshot(docs => {
      this.faults = []
      docs.forEach( async (doc) => {
        let item = doc.data()
        item.id = doc.id
        if (item.mechanic) {
          let mechData = await item.mechanic.get();
          item.mechanic = mechData.data();
          item.mechanic.id = mechData.id
        }
        this.faults.push(item)
      });
      // Add a store dispatch here to push faults to state
      //
      // Move computed notificaiton filters to state getters
      //
      // Update template to use state getters where ever you need the notification bubbles. Only subscribe here.
    }, err => {
      console.log(`Encountered error: ${err}`);
    });

    const approvedUserRef = fb_db.collection("users").where("approved", "==", false)
    .where("puic", "==", user.puic)
    this.approvedObserver = approvedUserRef.onSnapshot(docs => {
      this.approved = []
      docs.forEach(doc => {
        let item = doc.data()
        item.id = doc.id
        this.approved.push(item)
      });
    }, err => {
      console.log(`Encountered error: ${err}`);
    });

    const partsRef = fb_db.collection("parts").where("puic", "==", user.puic)
    .where("status", "==", "Needs Ordered")
    this.partsObserver = partsRef.onSnapshot(docs => {
      this.parts = []
      docs.forEach(doc => {
        let item = doc.data()
        item.id = doc.id
        this.parts.push(item)
      });
    }, err => {
      console.log(`Encountered error: ${err}`);
    });
  },
  destroyed () {
    this.faultsOberver()
    this.approvedObserver()
    this.partsObserver()
  },

  methods: {
    closeMenu() {
      this.$emit("menuclicked");
    },
    loginChat(evt) {
      evt.preventDefault();

      router.push({
        name: "RoomList",
        params: { nickname: this.userProfile.lastname },
      });
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    userProfile() {
      return this.$store.state.userProfile;
    },
    assigned() {
      return this.faults.filter((f)=>{
        return f.status == 'Assigned'
      })
    },
    notassigned() {
      return this.faults.filter((f)=>{
        return f.status == 'Not Assigned'
      })
    },
    verified() {
      return this.faults.filter((f)=>{
        return f.status == 'Verified'
      })
    },
    notentered() {
      return this.faults.filter((f)=>{
        return f.status == 'Needs Entered In GCSS'
      })
    },
    MechanicNotifications() {
      return this.faults.filter((f)=>{
        return f.status == 'Assigned' && f.mechanic.id == this.userProfile.id
      })
    },
    MMnotifications() {
      return this.faults.filter((f)=>{
        return f.status == 'Assigned' && f.mechanic.id == this.userProfile.id || f.status == 'Verified' || f.status == 'Not Assigned' 
      })
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/theme.scss";

.role_links {
  a {
    display: block;
    text-decoration: none;
    font-weight: 300;
    margin: 30px 0px;
    padding-left: 10px;

    &.router-link-exact-active {
      border-left: 3px solid $primary;
      padding-left: 7px;
    }

    &:hover {
      color: $primary;
    }
  }

  .separator {
    width: 85%;
    height: 2px;
    background: #ffc400;
    margin: 15px 0px 30px 0px;
  }

.notassigned{
  background-color: red;
  color: white;
    right: auto !important;
  }
  .assigned{
  background-color: #749df5;

  }
  .approved{
  background-color: red;
    color: white;
    right: auto !important;
  }
    .notentered{
  background-color: red;
    color: white;
    right: auto !important;
  }

    .verified{
  background-color:#ffc400

  }

.p-overlay-badge .p-badge {
  position: relative;
}
}
</style>
